function NotFound() {
  return (
    <div className="container mt-5 pt-5">
      <h1>404-Not Found!</h1>
    </div>
  );
}

export default NotFound;
